var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['show-hide-item', { visible: _vm.actualVisible }],on:{"click":_vm.click}},[_c('i',{class:_vm.iconClasses}),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }